import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { UserMapper } from "@app/core/user/data/network/user.mapper";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { User } from "@app/core/user/domain/user";

@Injectable({
  providedIn: "root",
})
export class GetUserProfileWS {
  constructor(private handler: BaseHandler) {}

  execute(token: string): Observable<User> {
    const parameters = new HandlerBuilder()
      .setMethod(HttpMethod.get)
      .setAuthorization(new TokenAuthorization(token))
      .setUrl(ApiUrls.GET_USER_PROFILE_ENDPOINT())
      .build();

    return this.handler
      .execute(parameters)
      .pipe(map((response) => UserMapper.deserialize(response)));
  }
}
